<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.782 1.5a4.499 4.499 0 0 0-4.437 3.785l-.89-.888-.705.705 2.123 2.123 2.12-2.122-.708-.708-.935.935A3.503 3.503 0 0 1 6.782 2.5c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5v1a4.5 4.5 0 0 0 0-9Z" />
</svg>
